import fuzzysort from "fuzzysort"
import PropTypes from "prop-types"
import React, { Component } from "react"

import BrandAndModel from "./BrandAndModel"
import styles from "./BrandAndModelSelector.module.sass"
import withBrandAndModel from "./withBrandAndModel"

const createBrandObject = (obj) => {
  return {
    label: obj.brand,
    value: obj,
  }
}

const KEY_CODE_BACKSPACE = 8

class BrandSelector extends Component {
  static propTypes = {
    autoFocus: PropTypes.bool.isRequired,
    topBrands: PropTypes.array.isRequired, // ["Audi", "Nissan", "Ford"]
    all: PropTypes.array.isRequired, // [["Audi", ["A3", "A4", "Q5"]], ["BMW", ["112"]]]
    doneCallback: PropTypes.func,
    initiallySelected: PropTypes.object,
    labels: PropTypes.object,
    visibleBrands: PropTypes.array.isRequired,
    theme: PropTypes.object.isRequired,
    onTypedTextChange: PropTypes.func.isRequired,
    onResultsChange: PropTypes.func.isRequired,
    onItemSelect: PropTypes.func.isRequired,
    textInputChange: PropTypes.func.isRequired,
    textInputBlur: PropTypes.func.isRequired,
    typedText: PropTypes.string.isRequired,
    inputFocused: PropTypes.bool.isRequired,
    results: PropTypes.array.isRequired,
  }

  constructor(props) {
    super(props)

    const initiallySelectedBrand = this.initiallySelectedBrand()
    const typedText = initiallySelectedBrand.inputText || ""
    const results = this.initialResults(initiallySelectedBrand.brand, typedText)

    this.state = {
      brand: initiallySelectedBrand.brand,
    }

    props.onTypedTextChange(typedText)
    props.onResultsChange(results)
  }

  // Selects brand based on initial props
  initiallySelectedBrand() {
    const { initiallySelected } = this.props

    if (initiallySelected && initiallySelected.brand) {
      return {
        brand: initiallySelected.brand,
        inputText: initiallySelected.brand || "",
      }
    }

    return {}
  }

  initialResults(brand, typedText) {
    if (!brand && !typedText) return this.defaultBrandsResults()

    if (typedText) return this.searchResultsFor(brand, typedText)
  }

  defaultBrandsResults() {
    return [
      {
        options: this.props.topBrands.map((brand) =>
          createBrandObject({ brand })
        ),
      },
      {
        category: "A-Z",
        options: this.props.visibleBrands.map((brand) =>
          createBrandObject({ brand })
        ),
      },
    ]
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.typedText !== prevProps.typedText ||
      this.state.brand !== prevState.brand
    ) {
      this.props.onResultsChange(
        this.searchResultsFor(this.state.brand, this.props.typedText)
      )
    }
  }

  textInputKeyDown = (e) => {
    if (e.keyCode === KEY_CODE_BACKSPACE && this.state.brand) {
      this.setState({
        brand: null,
      })
    }
  }

  // Returns the search result for the given brand and typed text
  searchResultsFor(brand, inputText) {
    if (!brand && !inputText) return this.defaultBrandsResults()

    const resultsFiltered = fuzzysort
      .go(
        inputText || brand,
        this.props.all.map(([brand]) => ({ brand })),
        { key: "brand" }
      )
      .map(({ obj }) => createBrandObject(obj))

    const results =
      resultsFiltered.length > 0
        ? [{ options: resultsFiltered }]
        : this.defaultBrandsResults()
    this.props.onResultsChange(results)
    return results
  }

  render() {
    return (
      <BrandAndModel
        autoFocus={this.props.autoFocus}
        value={this.props.typedText}
        onChange={this.props.textInputChange}
        onBlur={this.props.textInputBlur}
        onKeyDown={this.textInputKeyDown}
        focused={this.props.inputFocused}
        classNameInput={styles.input}
        inputPlaceholder={this.props.labels.placeholders.brand}
        choices={this.props.results}
        selectItem={this.props.onItemSelect}
        theme={this.props.theme}
        labelSeeAll={this.props.labels.seeAll}
        labelClose={this.props.labels.close}
      />
    )
  }
}

export default withBrandAndModel(BrandSelector, "brand", "brand")
